// App
import styled from 'styled-components';
import { stacked } from 'app/shared/styles/_spacing';
import type { ComponentType } from 'react';

// Base components
import CheckboxBase from 'app/shared/modules/MobileSRP/__BaseComponents__/Checkbox';

export const Container = styled.div`
  position: relative; // Needed to prevent weird CSS overscrolling issues w/ the checkbox
  padding-left: 6px;
`;

export const Checkbox: ComponentType<React.ComponentProps<typeof CheckboxBase>> = styled(CheckboxBase)`
  ${stacked._1x};
  display: flex;
`;
